// extracted by mini-css-extract-plugin
export default {"richText":"richTextViewer_richText__Ob6-A"};